const buttonEl = document.querySelector('.menu-toggle')
buttonEl.addEventListener('click', toggleBody)

function toggleBody() {
    let bodyEl = document.querySelector('body')
    bodyEl.classList.toggle('open')
}